<template>
  <div class="content-page">
    <div class="mian-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <el-form :model="search" inline>
            <el-form-item class="col1-6" label="编号" prop="caseNo">
              <el-input v-model="search.inquireNo" placeholder="请输入案号"></el-input>
            </el-form-item>
            <el-form-item class="col1-6" label="案号" v-if="searchType != 1" prop="caseNo">
              <el-input v-model="search.caseNo" placeholder="请输入案号"></el-input>
            </el-form-item>
            <el-form-item class="col1-6" label="被申请人" prop="respondentName">
              <el-input v-model="search.respondentName" placeholder="请输入被申请人"></el-input>
            </el-form-item>
            <el-form-item class="col1-6" label="复议机关" prop="reconsiderationAgency">
              <el-input v-model="search.reconsiderationAgency" placeholder="请输入复议机关"></el-input>
            </el-form-item>
            <el-form-item class="col1-6" label="案由" prop="caseCause" v-if="searchType != 1">
              <el-input v-model="search.caseCause" placeholder="请输入案由"></el-input>
            </el-form-item>
            <el-form-item class="col1-6">
              <el-button type="primary" @click="searchFn">搜索</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button
                type="primary"
                style="margin-left: 60px;"
                @click="$router.push('/selectType')"
              >返回上一页</el-button>
            </el-form-item>
          </el-form>
          <el-tabs type="border-card" v-model="searchType" @tab-click="tabsChange">
            <!-- 案件信息 -->
            <el-tab-pane label="案件信息" name="0">
              <div class="re-contentBox">
                <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                  <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
                  <el-table-column align="center" prop="inquireNo" label="申请编号">
                    <template slot-scope="scope">
                       <span>{{ scope.row.inquireNo || '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="caseNo" label="案号"></el-table-column>
                  <el-table-column align="center" prop="applicantName" label="申请人"></el-table-column>
                  <el-table-column align="center" prop="respondentName" label="被申请人"></el-table-column>
                  <el-table-column align="center" prop="reconsiderationAgencyName" label="复议机关"></el-table-column>
                  <el-table-column align="center" prop="filingTime" label="提交时间"></el-table-column>
<!--                  <el-table-column align="center" prop="slTime" label="受理时间">
                    <template slot-scope="scope">
                      <div v-if="scope.row.hasSlsc == 1">
                        <span v-if="scope.row.tcEndTime">{{ scope.row.tcEndTime }}</span>
                        <span v-else>{{ scope.row.filingTime }}</span>
                      </div>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>-->
                  <el-table-column align="center" prop="caseCause" label="案由"></el-table-column>
                  <el-table-column align="center" prop="wssqCaseStatusName" label="案件状态"></el-table-column>
                  <el-table-column align="center" prop="date" label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.correctionState == 1 && scope.row.wssqCaseStatus == 2 && indexofStr(scope.row.caseTips,'ajichz') == -1"
                        :class="{ 'btn-supplement-disabled': scope.row.correctionSyncState === 0 }"
                        @click="newCase(scope.row, 1)"
                      >补正</el-button>
                      <el-button
                        v-if="oprate == 'search' && scope.row.opinionBtn"
                        type="text"
                        @click="openOpinionDialog(scope.row)"
                      >听取意见</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.wssqCaseStatus == 3"
                        :class="{ 'btn-supplement-disabled': indexofStr(scope.row.caseTips,'ajbc') != -1 }"
                        @click="newCase(scope.row, 2)"
                      >补充</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'revokeApply'"
                        @click="revoke(scope.row)"
                      >撤回</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 0 && scope.row.isAllocateHandleUser === 1"
                        @click="openReviewApplication(scope.row)"
                      >申请阅卷</el-button>
                      <el-popover
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 1 && scope.row.isAllocateHandleUser === 1"
                        placement="bottom"
                        width="300"
                        trigger="click"
                      >
                        <div style="padding: 10px; line-height: 20px;">
                          您的阅卷申请已提交，请耐心等待复议机关审批。
                        </div>
                        <el-button
                          slot="reference"
                          type="text"
                        >申请中</el-button>
                      </el-popover>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 2"
                        @click="openOnlineReview(scope.row)"
                      >在线阅卷</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 3"
                        @click="openRejectDialog(scope.row)"
                      >申请驳回</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <!-- 申请信息 -->
            <el-tab-pane label="申请信息" name="1">
              <div class="re-contentBox">
                <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                  <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
                  <el-table-column align="center" prop="inquireNo" label="申请编号"></el-table-column>
                  <el-table-column align="center" prop="applicantName" label="申请人"></el-table-column>
                  <el-table-column align="center" prop="respondentName" label="被申请人"></el-table-column>
                  <el-table-column align="center" prop="reconsiderationAgencyName" label="复议机关"></el-table-column>
                  <el-table-column align="center" prop="filingTime" label="提交时间"></el-table-column>
                  <!-- <el-table-column align="center" prop="slTime" label="受理时间">
                    <template slot-scope="scope">
                      <div v-if="scope.row.hasSlsc == 1">
                        <span v-if="scope.row.tcEndTime">{{ scope.row.tcEndTime }}</span>
                        <span v-else>{{ scope.row.filingTime }}</span>
                      </div>
                      <span v-else>-</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column align="center" prop="caseStatusName" label="案件状态"></el-table-column>
                  <el-table-column align="center" prop="date" label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'revokeApply'"
                        @click="revoke(scope.row)"
                      >撤回</el-button>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 0 && item.isAllocateHandleUser === 1"
                        @click="openReviewApplication(scope.row)"
                      >申请阅卷</el-button>
                      <el-popover
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 1"
                        placement="bottom"
                        width="300"
                        trigger="click"
                      >
                        <div style="padding: 10px; line-height: 20px;">
                          您的阅卷申请已提交，请耐心等待复议机关审批。
                        </div>
                        <el-button
                          slot="reference"
                          type="text"
                        >申请中</el-button>
                      </el-popover>
                      <el-button
                        type="text"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 2 && item.isAllocateHandleUser === 1"
                        @click="openOnlineReview(scope.row)"
                      >在线阅卷</el-button>
                      <el-button
                        type="text"
                        style="color: #ff4d4f;"
                        v-if="oprate == 'search' && scope.row.caseStatus === 6 && scope.row.applyStatus === 3"
                        @click="openRejectDialog(scope.row)"
                      >申请驳回</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>

          </el-tabs>

          <el-pagination
            background
            :page-size="pageSize"
            style="margin-left: auto;margin-top: 20px;text-align: right"
            :total="total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="currentPage"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
        <el-dialog
          title="听取意见"
          :visible.sync="opinionDialogVisible"
          width="600px"
          :close-on-click-modal="false"
          :append-to-body="true"
        >
          <div class="opinion-dialog-body">
            <div class="opinion-question">
              <div class="opinion-tip-question">请就您的复议案件发表意见。</div>
              <div>询问：{{ latestOpinion.question || '-' }}</div>
            </div>
            <el-form :model="opinionForm" label-width="0">
              <el-form-item>
                <div class="opinion-label">
                  <span class="required-star">*</span>请填写书面意见：
                </div>
                <el-input
                  type="textarea"
                  v-model="opinionForm.text"
                  :rows="6"
                  maxlength="1000"
                  show-word-limit
                  placeholder="请在此填写您对复议案件的意见（最多1000字）"
                />
              </el-form-item>
              <el-form-item>
                <div class="opinion-upload-row">
                  <el-upload
                    class="opinion-upload"
                    action=""
                    :http-request="handleOpinionUpload"
                    :limit="1"
                    :file-list="opinionFileList"
                    :on-remove="handleOpinionRemove"
                    :before-upload="beforeOpinionUpload"
                    :on-exceed="handleOpinionExceed"
                  >
                    <el-button type="primary" size="small">上传附件</el-button>
                    <span class="opinion-upload-tip">
                      (附件仅允许上传一个.doc、.pdf类型的文件，且文件大小需在20M以内)
                    </span>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="opinionForm.checked">
                  我确认以上内容真实，并同意复议机关据此审理本案。
                </el-checkbox>
              </el-form-item>
              <el-form-item class="bottom-button">
                <el-button @click="opinionDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmOpinion">确 定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
        <singDialog
          ref="singDialogOpinion"
          signType="opinion"
          :opera="1"
          :detailInfo="{ caseOrderNo: currentOpinionRow.caseOrderNo }"
          @signature-submit="handleOpinionSigned"
        />
        <revokeTip
          :caseOrderNo="caseOrderNo"
          :applicantInfo="applicantInfo"
          ref="revokeTip"
          @openCh="openCh"
        />
        <correctionsTip :caseOrderNo="caseOrderNo" ref="correctionsTip" @openCh="openCh" />
        
        <!-- 申请阅卷弹窗 -->
        <review-application
          v-if="reviewApplicationShow"
          ref="reviewApplication"
          :case-order-no="reviewApplicationItem ? reviewApplicationItem.caseOrderNo : ''"
          @confirm="handleReviewApplicationConfirm"
        />

        <!-- 在线阅卷弹窗 -->
        <online-review
          v-if="onlineReviewShow"
          ref="onlineReview"
          :case-order-no="onlineReviewItem ? onlineReviewItem.caseOrderNo : ''"
          :signature-name="loginName"
          :detail-info="{ caseInfo: onlineReviewItem || {} }"
          @confirm="handleOnlineReviewConfirm"
        />


        <!-- 申请驳回理由弹窗 -->
        <el-dialog
          :visible.sync="rejectDialogShow"
          width="500px"
          :close-on-click-modal="true"
          custom-class="reject-dialog"
        >
          <div class="reject-dialog-content" style="white-space: pre-wrap; line-height: 24px;">
            <!-- <div class="title">您的阅卷申请被驳回，</div> -->
            <div>{{rejectReason}}</div>
          </div>
        </el-dialog>
        <!--   撤回书预览   -->
        <el-dialog
          :fullscreen="true"
          v-if="fileReviewDialog"
          :visible.sync="fileReviewDialog"
          title="撤回书预览"
          :close-on-click-modal="false"
          :show-close="true"
        >
          <div style="max-height: 80%; overflow-y: auto">
            <img v-for="(item,index) in imgList" :key="index" :src="item.fileBaseUri" />
          </div>
          <span slot="footer">
            <el-button type="primary" @click="doSubmit">撤回</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
import revokeTip from './DetailCase/components/revokeTip'
import correctionsTip from './NewCase/components/correctionsTip'
import ReviewApplication from './components/reviewApplication.vue'
import OnlineReview from './components/onlineReview.vue'
import singDialog from '@/components/singDialog/singDialog'
export default {
  name: 'caseList',
  data () {
    return {
      searchType: this.$route.query.searchType?.toString() || '0',
      loading: false,
      tableData: [],
      imgList: [],
      identificationCard: this.$route.query.identificationCard || '',
      phone: this.$route.query.phone || '',
      applicantCategory: this.$route.query.applicantCategory || '',
      loginName: this.$route.query.loginName || '',
      currentPage: 1,
      pageSize: 10,
      search: {
        caseNo: '',
        respondentName: '',
        reconsiderationAgency: '',
        caseCause: ''
      },
      applicantInfo: [
        {
          name: ''
        }
      ],
      caseOrderNo: '',
      total: 0,
      writList: [],
      fileReviewDialog: false,
      oprate: localStorage.getItem('oprate'),
      reviewApplicationShow: false,
      reviewApplicationItem: null,
      onlineReviewShow: false,
      onlineReviewItem: null,
      rejectDialogShow: false,
      rejectReason: '',
      // 听取意见
      opinionDialogVisible: false,
      currentOpinionRow: {},
      latestOpinion: {
        question: '',
        listenOpinionId: '',
      },
      opinionForm: {
        text: '',
        checked: false
      },
      opinionFileList: []
    }
  },
  components: {
    revokeTip,
    correctionsTip,
    ReviewApplication,
    OnlineReview,
    singDialog
  },
  watch: {
    writList: function (newVal) {
      if (newVal) {
        newVal.map(item => {
          item.fileBaseUri = 'data:image/png;base64,' + item.fileBaseUri
        })
        this.imgList = newVal
      }
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    // 选项卡切换
    tabsChange (event) {
      // 存储是申请/案件信息参数
      this.searchType = event.name
      this.currentPage = 1
      this.getlist()
    },
    // 撤回
    doSubmit () {
      this.$confirm('是否确认撤回申请书无误?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const withdrawSource = +this.$route.query.searchType + 1
        Api.revoke({
          caseSource: 4,
          caseOrderNo: this.caseOrderNo,
          inquireNo: withdrawSource === 2 ? this.detailInfo.inquireNo : '',
          withdrawSource
        }).then(({ data }) => {
          this.fileReviewDialog = false
          if (data.code == 0) {
            this.$alert(
              '您已确认撤回申请，后续将由工作人员进行确认，您可以通过“我要查询”模块查询案件进展',
              '提示',
              {
                confirmButtonText: '确定',
                callback: action => {
                  this.getlist()
                }
              }
            )
          }
        })
      })
    },
    openCh (data) {
      console.log(data)
      this.fileReviewDialog = true
      console.log(data.data.showImgPathList)
      this.writList = data.data.showImgPathList
    },
    revoke (item) {
      this.$router.push({
        name: 'DetailCase',
        query: {
          from: 'list',
          isRevoke: 1,
          number: item.caseOrderNo,
          searchType: this.searchType
        }
      })
    },
    newCase (item, opera) {
      if (opera == 1) {
        // 已提交补正材料则不允许再次补正
        if (item.correctionSyncState === 0) {
          this.$alert('您已提交补正材料，请耐心等候', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          })
          return
        }
        this.caseOrderNo = item.caseOrderNo
        this.$refs.correctionsTip.open()
        // 点击补正校验是否48小时
        // Api.correctionCheck({
        //   caseOrderNo: item.caseOrderNo
        // }).then(({ data }) => {
        //   if(data.code == 0){
        //     this.$router.push({
        //       name: 'NewCase',
        //       query: {
        //         name: 'caseList',
        //         number: item.caseOrderNo,
        //         opera
        //       }
        //     })
        //   }
        // })
      } else {
        // 补充
        if (this.indexofStr(item.caseTips, 'ajbc') != -1) {
          this.$alert('你已提交过补充材料', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          })
          return
        }
        this.$router.push({
          name: 'NewCase',
          query: {
            name: 'caseList',
            number: item.caseOrderNo,
            opera
          }
        })
      }
    },
    openOpinionDialog (row) {
      this.currentOpinionRow = row
      Api.getLatestOpinion({ caseOrderNo: row.caseOrderNo }).then(({ data }) => {
        if (data.code == 0 && data.data) {
          this.latestOpinion = {
            question: data.data.informContent || '-',
            listenOpinionId: data.data.listenOpinionId || ''
          }
        } else {
          this.latestOpinion = {
            question: '-',
            listenOpinionId: '',
          }
        }
      }).catch(() => {
        this.latestOpinion = {
          question: '-',
          listenOpinionId: '',
        }
      })
      this.opinionForm = {
        text: '',
        checked: false
      }
      this.opinionFileList = []
      this.opinionDialogVisible = true
    },
    beforeOpinionUpload (file) {
      if (this.opinionFileList.length >= 1) {
        this.$message.warning('只能上传一个文件，请先删除已有文件')
        return false
      }
      const ext = file.name.split('.').pop().toLowerCase()
      const allow = ['doc', 'docx', 'pdf']
      if (!allow.includes(ext)) {
        this.$message.error('仅支持上传 WORD 或 PDF 文件')
        return false
      }
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('文件大小需在20M以内')
        return false
      }
      return true
    },
    handleOpinionExceed (files, fileList) {
      this.$message.warning('只能上传一个文件，请先删除已有文件')
    },
    handleOpinionUpload (request) {
      const { file } = request
      if (this.opinionFileList.length > 0) {
        this.$message.warning('只能上传一个文件，请先删除已有文件')
        request.onError && request.onError()
        return
      }
      const loadingInstance = this.$loading({
        lock: true,
        text: '文件上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('file', file)
      formData.append('caseOrderNo', this.currentOpinionRow.caseOrderNo)
      formData.append('kindType', '7') // 假设7表示听取意见附件
      Api.appletsUpload(formData)
        .then(({ data }) => {
          console.log('上传响应:', data)
          if (loadingInstance) {
            loadingInstance.close()
          }
          if (data && data.data && data.data.id) {
            this.opinionFileList = [
              {
                name: file.name,
                status: 'success',
                uid: file.uid,
                fileId: data.data.id
              }
            ]
            request.onSuccess && request.onSuccess({}, file)
            this.$message.success('文件上传成功')
          } else {
            console.error('上传响应数据结构异常:', data)
            this.$message.error('文件上传失败：响应数据格式错误')
            request.onError && request.onError()
          }
        })
        .catch((error) => {
          // 确保loading关闭
          if (loadingInstance) {
            loadingInstance.close()
          }
          console.error('文件上传失败:', error)
          this.$message.error('文件上传失败，请重试')
          request.onError && request.onError()
        })
        .finally(() => {
          if (loadingInstance) {
            setTimeout(() => {
              loadingInstance.close()
            }, 100)
          }
        })
    },
    handleOpinionRemove () {
      this.opinionFileList = []
    },
    confirmOpinion () {
      if (!this.opinionForm.text) {
        this.$message.warning('请填写书面意见')
        return
      }
      if (this.opinionForm.text.length > 1000) {
        this.$message.warning('书面意见最多支持1000字')
        return
      }
      if (!this.opinionForm.checked) {
        this.$message.warning('请先勾选确认以上内容真实')
        return
      }
      this.opinionDialogVisible = false
      this.$refs.singDialogOpinion && this.$refs.singDialogOpinion.open()
    },
    async handleOpinionSigned (event) {
      console.log('opinion signed', event)
      try {
        let fileIds = ''
        if (this.opinionFileList.length > 0) {
          const ids = this.opinionFileList
            .map(file => file.fileId)
            .filter(id => id)
          fileIds = ids.join(',')
        }
        const params = {
          caseOrderNo: this.currentOpinionRow.caseOrderNo,
          listenOpinionId: this.latestOpinion.listenOpinionId,
          applicantId: this.identificationCard,
          informContent: this.opinionForm.text,
          file: fileIds,
          signPath: event.uploadResult?.data?.evidencePath || ''
        }
        const { data } = await Api.addOpinion(params)
        if (data.code == 0) {
          this.$message.success('提交成功')
          this.opinionForm = {
            text: '',
            checked: false
          }
          this.opinionFileList = []
          this.getlist()
        } else {
          this.$message.error(data.msg || '提交失败，请重试')
        }
      } catch (error) {
        console.error('提交听取意见失败:', error)
        this.$message.error('提交失败，请重试')
      }
    },
    searchFn () {
      this.currentPage = 1
      this.getlist()
    },
    reset () {
      this.currentPage = 1
      this.search = {
        caseNo: '',
        respondentName: '',
        reconsiderationAgency: '',
        caseCause: ''
      }
      this.getlist()
    },
    goDetail (item) {
      this.$router.push({
        name: 'DetailCase',
        query: {
          from: 'list',
          searchType: this.searchType,
          number: item.caseOrderNo
        }
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.getlist()
    },
    sizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getlist()
    },
    indexofStr (str1, str2) {
      return str1 ? str1.indexOf(str2) : -1
    },
    // 打开申请阅卷弹窗
    openReviewApplication (item) {
      this.reviewApplicationItem = item
      this.reviewApplicationShow = true
      this.$nextTick(() => {
        if (this.$refs.reviewApplication) {
          this.$refs.reviewApplication.open()
        }
      })
    },
    // 确认申请阅卷
    handleReviewApplicationConfirm (data) {
      console.log('申请阅卷确认', data)
      this.reviewApplicationShow = false
      this.reviewApplicationItem = null
      // 刷新列表
      this.getlist()
    },
    // 打开在线阅卷弹窗
    openOnlineReview (item) {
      // 判断 reviewFilesIsRead 字段
      // 如果为 0，打开 onlineReview 和 signCanvas 组件
      // 如果为 1，直接跳转到文件列表页 reviewList
      if (item.reviewFilesIsRead === 0 || item.reviewFilesIsRead === '0') {
        // 未阅卷，需要签名
        this.onlineReviewItem = item
        this.onlineReviewShow = true
        this.$nextTick(() => {
          if (this.$refs.onlineReview) {
            this.$refs.onlineReview.open()
          }
        })
      } else if (item.reviewFilesIsRead === 1 || item.reviewFilesIsRead === '1') {
        // 已阅卷，跳转到文件列表页
        // 格式化申请时间
        const filingTime = item.filingTime || item.filingTimeFormat || ''
        let filingTimeStr = ''
        if (filingTime) {
          const date = new Date(filingTime.replace(/-/g, '/'))
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const day = date.getDate()
          filingTimeStr = `${year}年${month}月${day}日`
        }
        
        // 跳转到阅览列表页面，传递申请人信息和申请时间
        const applicantName = encodeURIComponent(item.applicantName || '')
        
        this.$router.push({
          name: 'ReviewList',
          query: {
            caseOrderNo: item.caseOrderNo,
            applicantName: applicantName,
            filingTime: encodeURIComponent(filingTimeStr)
          }
        }).catch(err => {
          console.error('跳转失败', err)
          this.$message.error('跳转失败，请重试')
        })
      } else {
        // 默认情况，打开 onlineReview 组件
        this.onlineReviewItem = item
        this.onlineReviewShow = true
        this.$nextTick(() => {
          if (this.$refs.onlineReview) {
            this.$refs.onlineReview.open()
          }
        })
      }
    },
    
    // 关闭在线阅卷弹窗
    closeOnlineReview() {
      this.onlineReviewShow = false
      this.onlineReviewItem = null
    },
    // 确认在线阅卷
    handleOnlineReviewConfirm (data) {
      console.log('在线阅卷确认', data)
      
      // 获取当前案件信息
      const item = this.onlineReviewItem
      if (!item) {
        this.$message.error('案件信息不存在')
        this.closeOnlineReview()
        return
      }
      
      // 关闭在线阅卷弹窗
      this.closeOnlineReview()
      
      // 格式化申请时间
      const filingTime = item.filingTime || item.filingTimeFormat || ''
      let filingTimeStr = ''
      if (filingTime) {
        const date = new Date(filingTime.replace(/-/g, '/'))
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        filingTimeStr = `${year}年${month}月${day}日`
      }
      
      // 跳转到阅览列表页面，传递申请人信息和申请时间
      const applicantName = encodeURIComponent(item.applicantName || '')
      
      this.$router.push({
        name: 'ReviewList',
        query: {
          caseOrderNo: item.caseOrderNo,
          applicantName: applicantName,
          filingTime: encodeURIComponent(filingTimeStr)
        }
      }).catch(err => {
        console.error('跳转失败', err)
        this.$message.error('跳转失败，请重试')
      })
    },
    // 打开驳回理由弹窗
    openRejectDialog (item) {
      this.rejectReason = item.rejectReason || ''
      this.rejectDialogShow = true
    },
    // 关闭驳回理由弹窗
    closeRejectDialog () {
      this.rejectDialogShow = false
      this.rejectReason = ''
    },
    getlist () {
      const {
        identificationCard,
        phone,
        applicantCategory,
        loginName,
        oprate
      } = this
      const params = {
        loadMore: true,
        ...this.search,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      const filter = {
        identificationCard,
        applicantName: loginName,
        phone
      }
      if (oprate == 'revokeApply') {
        filter.isToWithdraw = '1'
      }

      if (oprate == 'search') {
        filter.isToWithdraw = ''
      }

      // 查询网上申请的信息
      if (this.searchType == 1) {
        filter.searchType = 1
      }
      this.loading = true
      Api.getCaseList({
        applicantCategory,
        ...filter,
        ...params
      }).then(({ data }) => {
        console.log(data)
        let list = []
        list = data.data ? data.data.list || [] : []
        list.forEach(item => {
          if (item.reconsiderationAgencyName) {
            item.reconsiderationAgencyName = item.reconsiderationAgencyName.startsWith(
              '上海市'
            )
              ? item.reconsiderationAgencyName
              : '上海市' + item.reconsiderationAgencyName
          }
          // formatDate
          item.tcEndTime = item.tcEndTime
            ? this.$moment(item.tcEndTime).format('yyyy-MM-DD')
            : ''
          item.filingTime = this.$moment(item.filingTime).format('yyyy-MM-DD')
        })
        this.tableData = list
        this.total = data.data ? data.data.total || 0 : 0
        this.loading = false
      }).catch((msg) => {
        console.log(msg)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
// 已补充过：补充按钮置灰
.btn-supplement-disabled {
  color: #c0c4cc !important;
  cursor: not-allowed;
}
.main-contentBox {
  padding: 30px 20px 40px;
  width: 100%;
  height: auto;
  .re-contentBox {
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    // box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    justify-content: center;
    .textBox {
      width: 80%;
      .tiptext {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
      .codebtn {
        width: 105px;
        height: 30px;
        background: #5a89fd;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: pointer;
      }
      .codebtn-gary {
        width: 105px;
        height: 30px;
        background: #ccc;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: not-allowed;
      }
    }
  }
}

::v-deep .reject-dialog {
  .el-dialog__header {
    background-color: #ffffff;
    padding: 0px 20px 0px;
    .el-dialog__headerbtn {
      i {
        color: #000;
      }
    }
  }
  .el-dialog__body {
    padding: 0px 34px 10px 34px;
  }
  .reject-dialog-content {
    text-align: left;
    .title {
      text-align: center;
    }
  }
}
.opinion-dialog-body {
  font-family: MicrosoftYaHei, Arial, sans-serif;
  font-size: 14px;
  color: #303133;
  .el-form-item {
    margin-bottom: 4px !important;
  }
}

.opinion-question {
  margin-bottom: 12px;
  line-height: 24px;
  font-weight: 500;
}

.opinion-question > div:first-child {
  font-weight: 600;
  margin-bottom: 4px;
  margin:0px 0px 16px 0px;
}

.opinion-label {
  margin-bottom: 4px;
  font-weight: 500;
  color: #303133;
}

.required-star {
  color: #f56c6c;
  margin-right: 4px;
}

.opinion-upload-row {
  display: flex;
  align-items: center;
}

.opinion-upload-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}

.opinion-upload ::v-deep .el-upload-list {
  margin-top: 4px;
}

.bottom-button {
  text-align: right;
}
</style>
